import * as React from 'react'
import clsx from 'clsx'
import { Grid, Typography } from '@mui/material'
import SubMenuCard from './subMenuCard'
import { Nunito } from '@next/font/google'
import useStyles from './styles'
import { lato } from '@styles/fonts'
import { ClickAwayListener } from '@mui/material'
const nunito = Nunito({ subsets: ['latin'] })

interface MenuData {
  id: number
  itemName: string
  itemUrl: string
}

interface SubMenuType {
  heading: string
  subHeading?: string
  menuDataList?: MenuData[]
  button?: React.ReactNode | JSX.Element
  endCard?: React.ReactNode | JSX.Element
  className?: string
  closeSubMenu: () => void
}

const SubMenu: React.FC<SubMenuType> = ({
  heading,
  subHeading,
  menuDataList,
  button,
  endCard,
  className,
  closeSubMenu,
}: SubMenuType) => {
  const { classes } = useStyles()

  return (
    <ClickAwayListener
      onClickAway={() => {
        closeSubMenu()
      }}
    >
      <Grid
        container
        className={clsx(nunito.className, classes.root, className)}
      >
        <Grid container item sm={5.5} className={classes.titleContainer}>
          <Typography
            variant="h3"
            component="h2"
            className={classes.subMenuHeading}
          >
            {heading}
          </Typography>
          <Typography
            variant="body1"
            component="h2"
            className={clsx(lato.className, classes.subHeading)}
          >
            {subHeading}
          </Typography>
          {button}
        </Grid>
        <Grid container item sm={6.5} className={classes.subMenuContainer}>
          {menuDataList?.map((menu: MenuData, idx: number) => {
            if (idx == menuDataList.length - 1) return ''
            return (
              <Grid item sm={6} key={idx} className={classes.cardGrid}>
                <SubMenuCard
                  key={menu.id}
                  text={menu.itemName}
                  route={menu.itemUrl}
                  className={classes.cardBorder}
                  closeSubMenu={closeSubMenu}
                />
              </Grid>
            )
          })}
          <Grid item sm={6} className={classes.emergencyCard}>
            {endCard}
          </Grid>
        </Grid>
      </Grid>
    </ClickAwayListener>
  )
}

export default SubMenu
